export const CREATE_TOP10_GAME_COMPLETED = "top10game/createGameCompleted";
export const GET_TOP10_BOARD_COMPLETED = "top10game/getBoardCompleted";
export const VALIDATE_TOP10_SLOT_COMPLETED = "top10game/validateSlotCompleted";
export const AUTOCOMPLETE_TOP10_PILOTS_COMPLETED = "top10game/autocompletePilotsCompleted";
export const REVEAL_ALL_TOP10_COMPLETED = "top10game/revealAllCompleted";
export const SET_TOP10_SUGGESTIONS = "top10game/setSuggestions";